const profiles = {
  MANAGER: "Gestor",
  ADMIN: "Administrador",
  EDITOR: "Editor",
};
export default profiles;
